import React from "react";
import "./navbar.scss";
import { FaBars, FaMoon, FaSun, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Themeset } from "../../Redux/Theme";
import { MobileMenu } from "../../Redux/Toggle";
import Logo from "../../Img/ss.png";


const Navbar = () => {
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.theme.value);
  const toggle = useSelector((state) => state.toggle.value);

  return (
    <div className="navbar flex">
      <a href="/" className="logo">
        <img src={Logo} alt="logo" />
      </a>
      <ul className="navbar-nav flex">
        <li className="nav-item">
          <a href="/">Home</a>
        </li>
        <li className="nav-item">
          <a href="#about">About</a>
        </li>
        <li className="nav-item">
          <a href="#skills">Skills</a>
        </li>
        <li className="nav-item">
          <a href="#portfolio">Portfolio</a>
        </li>
        <li className="nav-item">
          <a href="#contact">Contact</a>
        </li>
      </ul>

      <ul className={`navbar-mobile column ${toggle ? null : "off"}`}>
        <li className="nav-item">
          <a href="/">Home</a>
        </li>
        <li className="nav-item" onClick={() => {
            dispatch(MobileMenu());
          }}>
          <a href="#about">About</a>
        </li>
        <li className="nav-item" onClick={() => {
            dispatch(MobileMenu());
          }}>
          <a href="#skills">Skills</a>
        </li>
        <li className="nav-item" onClick={() => {
            dispatch(MobileMenu());
          }}>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li className="nav-item" onClick={() => {
            dispatch(MobileMenu());
          }}>
          <a href="#contact">Contact</a>
        </li>
      </ul>
      <div className="set flex">
        <div
          className="navbar-toggler"
          onClick={() => {
            dispatch(MobileMenu());
          }}
        >
          {toggle ? <FaTimes /> : <FaBars />}
        </div>
        <div className="theme-toggle">
          <h1
            onClick={() => {
              dispatch(Themeset());
            }}
          >
            {theme ? <FaSun /> : <FaMoon />}
          </h1>
        </div>
        <div className="color-mode">

        </div>
      </div>
    </div>
  );
};

export default Navbar;
